import Tool, {
  type ToolArgs,
  type ToolArgsWithController,
} from '../../../tools/Tool';
import { type Descendant, Editor, Transforms } from 'slate';
import TableUtils from '../TableUtils';
import EditorUtils from '../../../AhaEditorUtils/EditorUtils';
import { isTableCellElement } from '../../../types/guards';
import InsertTableSizer from '../components/InsertTableSizer';

// Insert a table into the editor.
class ToolInsertTable extends Tool {
  static toolName = 'Table';
  static ariaLabel = 'Table';
  static iconClass = 'fa-regular fa-table';

  static action({
    editor,
    rows = 2,
    columns = 2,
  }: ToolArgsWithController & {
    rows: number;
    columns: number;
  }): void {
    if (!editor.selection) return;

    // Table nesting is not currently supported.
    if (TableUtils.currentTable(editor)) return;

    const children: Descendant[] = Array.from({ length: rows }, () => ({
      type: 'table-row',
      children: Array.from({ length: columns }, () => ({
        type: 'table-cell',
        children: [EditorUtils.emptyParagraph()],
      })),
    }));

    Transforms.insertNodes(editor, {
      type: 'table',
      children,
    });

    // Select the first cell in the table
    const tablePath = TableUtils.currentTablePath(editor);
    if (tablePath) {
      const [node] = Editor.nodes(editor, {
        at: tablePath,
        match: isTableCellElement,
      });
      Transforms.select(editor, node[1]);
    }
  }

  static toolbarSubmenu() {
    return InsertTableSizer;
  }

  static isEnabled({ editor }: ToolArgs): boolean {
    if (!editor?.selection) return false;
    // Table nesting is not currently supported.
    return !TableUtils.currentTable(editor);
  }
}

export default ToolInsertTable;
